import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  isMobile: BehaviorSubject<any>;
  isShowFooter: BehaviorSubject<any>;
  isShowMobileNav: BehaviorSubject<any>;
  isShowMobileBack: BehaviorSubject<any>;
  pageTitle: BehaviorSubject<any>;
  showPromotion: BehaviorSubject<any>;

  mobileLayoutConfig: BehaviorSubject<any>;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isMobile = new BehaviorSubject(this.deviceType == 'mobile');
    this.isShowFooter = new BehaviorSubject(true);
    this.isShowMobileNav = new BehaviorSubject(true);
    this.isShowMobileBack = new BehaviorSubject(false);
    this.showPromotion = new BehaviorSubject(false);
    this.pageTitle = new BehaviorSubject('');

    this.mobileLayoutConfig = new BehaviorSubject({
      headerNav: {
        visibillity: true,
        backButton: false,
        title: '',
        searchButton: true,
        cartButton: true,
        notificationButton: true,
        userButton: true,
      },
      bottomNav: {
        visibillity: true,
      },
    });
  }

  get deviceType(): string {
    if (isPlatformBrowser(this.platformId)) {
      const ua = window.navigator.userAgent;
      if (
        /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return 'mobile';
      }
      return 'desktop';
    } else {
      return '';
    }
  }
  public get isMobile$() {
    return this.isMobile;
  }
  public get isShowFooter$() {
    return this.isShowFooter;
  }
  public get showPromotion$() {
    return this.showPromotion;
  }
  public get mobileLayoutConfig$() {
    return this.mobileLayoutConfig;
  }
  public setFooterVisibility(isShowFooter: boolean) {
    this.isShowFooter.next(isShowFooter);
  }

  public setShowPromotion(showPromotion: boolean) {
    this.showPromotion.next(showPromotion);
  }

  public setDefaultMobileLayoutConfig() {
    this.mobileLayoutConfig.next({
      headerNav: {
        visibillity: true,
        backButton: false,
        title: '',
        searchButton: true,
        cartButton: true,
        notificationButton: true,
        userButton: true,
      },
      bottomNav: {
        visibillity: true,
      },
    });
  }

  public setMobileLayoutConfig(config: any) {
    let headerNav = Object.assign(
      this.mobileLayoutConfig.value.headerNav,
      config.headerNav
    );
    let bottomNav = Object.assign(
      this.mobileLayoutConfig.value.bottomNav,
      config.bottomNav
    );
    let newConfig = {
      headerNav: headerNav,
      bottomNav: bottomNav,
    };
    this.mobileLayoutConfig.next(newConfig);
  }
}
